module.exports = __webpack_public_path__ + "static/media/qyz_dl_bar.416f0fd6.png";